import newsletterFormInit from './newsletterForm';
import elementorInit from './elementor';

window.addEventListener('load', ()=>{
    newsletterFormInit();
    elementorInit();
})